<template>
  <Modal :title="title" :show-modal="showModal" @close="$emit('on-close')">
    <section class="flex justify-center w-full">
      <div>
        <h2 class="text-base">At {{ detailLeave.empleave_apply_date }}</h2>
        <p class="text-xs text-gray-400">
          Applied by
          <span class="text-blue-400">{{
            detailLeave.emp_id.emp_fullname
          }}</span>
        </p>
      </div>
      <section class="relative px-10 ml-10 border-l-2 h-52">
        <div
          class="absolute top-0 flex w-10 h-10 p-2 bg-gray-100 rounded-full -left-5"
        >
          <img src="@/assets/icons/log.svg" />
        </div>
        <div class="px-4 py-2 mt-10 bg-gray-100 rounded">
          <h2 class="flex items-center text-sm">
            {{ detailLeave.empleave_type_id.leave_name }}
            <span class="w-1.5 block h-1.5 rounded-full bg-gray-300 mx-4" />
            {{ detailLeave?.empleave_leave_duration }}
          </h2>
          <h2 class="mt-1 text-sm">
            {{ localDateString(detailLeave.empleave_start_date) }}
            {{ detailLeave.empleave_leave_type === "Multi Day" ? "to" : "" }}
            {{
              detailLeave.empleave_end_date &&
              localDateString(detailLeave.empleave_end_date)
            }}
          </h2>
          <div class="flex mt-2 text-xs text-gray-400">
            <font-awesome-icon icon="fa-file" />
            <article>
              <p class="ml-2">{{ detailLeave.empleave_reason }}</p>
            </article>
          </div>
        </div>
      </section>
    </section>
    <section class="mt-4">
      <label class="text-sm">Response Note</label>
      <textarea rows="4" class="w-full py-4 mt-2 border outline-primary">
      </textarea>
      <section class="grid items-center grid-cols-3 mt-4">
        <p class="text-sm">Update status</p>
        <div class="flex">
          <Radio
            label="Pending"
            value="Pending"
            :checked="detailLeave?.empleave_status === 'Pending'"
            @change="($event) => $emit('on-update-status', $event)"
          />
          <Radio
            label="Approved"
            class="mx-8"
            value="Approved"
            :checked="detailLeave?.empleave_status === 'Approved'"
            @change="($event) => $emit('on-update-status', $event)"
          />
          <Radio
            label="Rejected"
            value="Rejected"
            :checked="detailLeave?.empleave_status === 'Rejected'"
            @change="($event) => $emit('on-update-status', $event)"
          />
        </div>
      </section>
    </section>
    <template #footer>
      <section class="flex justify-between w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('on-close')"
        >
          Cancel
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          @click="
            $emit('on-edit-status', {
              id: detailLeave._id,
              empleave_status: detailLeave.empleave_status,
            })
          "
        >
          Save
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Radio from "@/components/Radio.vue";
import Button from "@/components/Button.vue";
export default {
  name: "ModalLeave",
  components: {
    Modal,
    Radio,
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showModal: {
      type: String,
      required: true,
    },
    detailLeave: {
      type: Object,
      required: true,
    },
  },
  methods: {
    localDateString(date) {
      let new_date = new Date(date);
      return new_date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
  },
};
</script>
